export const AppMixin = {
  computed: {
    pageTitle() {
      return (this.$route.meta && this.$route.meta.title) || this.$route.name;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/app-mixin.js